import { render, staticRenderFns } from "./prop-popover.vue?vue&type=template&id=f12d3858&"
import script from "./prop-popover.vue?vue&type=script&lang=ts&"
export * from "./prop-popover.vue?vue&type=script&lang=ts&"
import style0 from "./prop-popover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports